import { useState,useEffect } from "react";
import http from "../utils/http";
import uri from "../utils/uri";

const useProducts = ({areaId = 0,exists=false, active=false, has=false, reload=0, onlyProducts= false }) => {
    
    const [ isLoading, setIsLoading] = useState(true);
    const [ products, setProducts] = useState([]);   

    const callApi = async () => {
       
        const data = await http(uri.products.getByArea(areaId)).asGet({ exists, active, has, onlyProducts });        
       
        setProducts(data);
        setIsLoading(false);

    }
    
    useEffect(() => {
        callApi();
    }, [areaId, reload, active]);

    const refresh = callApi;

    return {
        products, 
        setProducts,
        isLoading,
        refresh
    }

}

export default useProducts;